import * as Yup from "yup";

const EditNoticeSchema = Yup.object().shape({
  description: Yup.string().required("Description is required"),
});

export default EditNoticeSchema;
